module.exports = __webpack_public_path__ + "static/media/linkedin.cd4c797a.svg";